// extracted by mini-css-extract-plugin
export default {"orderList":"myOrderList_orderList__RBwCi","loadingWrapper":"myOrderList_loadingWrapper__DF1MB","noOrderBox":"myOrderList_noOrderBox__j4VgA"};